import React from "react";

const Categories = () => {
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe
        src="https://www.gondalgroup.ae/45654367/store/" // change this to your actual PHP URL
        title="Store Module"
        style={{ width: "100%", height: "100%", border: "none" }}
        sandbox="allow-scripts allow-same-origin allow-forms allow-modals"
      />
    </div>
  );
};

export default Categories;
